import { useContext } from "react";

import { AuthContext, AuthContextValue } from "../contexts/authContext";

export default function useAuth(): Partial<AuthContextValue> {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error("useAuth must be used within a AuthProvider");
  }
  return {
    logIn: context.logIn,
    logOut: context.logOut,
    loading: context.loading,
    isAuthenticated: context.isAuthenticated,
    brokerGroupInfo: context.brokerGroupInfo,
    resetPassword: context.resetPassword,
    sessionEndMessage: context.sessionEndMessage,
  };
}
